/* eslint-disable */
import { BiShoppingBag, BiPencil } from "react-icons/bi";
import { BsCodeSlash, BsClipboardData } from "react-icons/bs";
import { AiOutlineMail, AiFillAudio } from "react-icons/ai";
import { FaInternetExplorer,  FaChalkboardTeacher, FaCameraRetro, FaPinterest, FaVideo, FaTabletAlt, FaRegNewspaper } from "react-icons/fa";
import { FaRobot, FaLaptopCode } from "react-icons/fa";


export const servicesData = [
    {
        id: 1,
        title: 'Software Development',
        icon: <BsCodeSlash />
    },
    {
        id: 2,
        title: 'AI & Machine Learning',
        icon: <FaRobot />
    },
    {
        id: 3,
        title: 'Full-Stack Development',
        icon: <FaLaptopCode />
    },
];

// Uncomment your required service.
// Couldn't find the required services? Raise an issue on github at https://github.com/hhhrrrttt222111/developer-portfolio/issues/new
// You can also add on your own 😉.